/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import clsx from 'clsx'
import {FormikValues} from 'formik'
import Select from 'react-select'
import {ISelectOption} from '../core/_model'

type Props = {
  formik?: FormikValues
  options?: ISelectOption[]
  fieldValue?: string
  placeholder: string
  setSelect?: (id: number, fielValue?: string) => void
  disable?: boolean
}

const dummyOptions: ISelectOption[] = [
  {id: 0, value: 'optionone', label: 'optionone'},
  {id: 1, value: 'optiontwo', label: 'optiontwo'},
  {id: 2, value: 'optionthree', label: 'optionthree'},
]

const ReactSelectBox = ({
  formik,
  options = dummyOptions,
  placeholder,
  fieldValue,
  setSelect,
  disable = false,
}: Props) => {
  // Find the currently selected option based on the fieldValue
  const selectedOption =
    options.find((option) => option.value === (formik ? formik.values[fieldValue!] : fieldValue)) ||
    null // Default to null if not found

  return (
    <Select
      name={fieldValue}
      className={clsx(
        'react-select-styled react-select custom-input',
        {
          'border-danger': formik?.touched[fieldValue!] && formik?.errors[fieldValue!],
        },
        {
          'border-success': formik?.touched[fieldValue!] && !formik?.errors[fieldValue!],
        }
      )}
      classNamePrefix='react-select'
      placeholder={placeholder}
      value={selectedOption} // Set the value to the selected option
      onChange={(selectedOption) => {
        formik && formik.setFieldValue(fieldValue!, selectedOption?.value || '') // Use optional chaining

        setSelect && setSelect(selectedOption?.id || 0, fieldValue)
      }}
      options={options}
      isSearchable={true}
      isDisabled={disable}
    />
  )
}

export default ReactSelectBox
